import { useCallback } from 'react';
import { endOfDay, endOfMonth, lastDayOfMonth, startOfMonth } from 'date-fns';

interface UseDateRangeProps {
  setStartDate: (date: string | null) => void;
  setEndDate: (date: string | null) => void;
}

export const useDateRange = ({ setStartDate, setEndDate }: UseDateRangeProps) => {
  const handleDateRange = useCallback(
    (dateRange: [Date | null, Date | null]) => {
      const [start, end] = dateRange;
      if (start) {
        const startDate = startOfMonth(new Date(start));
        startDate.setTime(startDate.getTime() - startDate.getTimezoneOffset() * 60000);
        const startstr = startDate.toISOString().substr(0, 19);
        setStartDate(startstr);
      } else {
        setStartDate(null);
      }

      if (end) {
        const lastDay = endOfDay(new Date(end));
        lastDay.setTime(lastDay.getTime() - lastDay.getTimezoneOffset() * 60000);
        const endstr = lastDay.toISOString().substr(0, 19);
        setEndDate(endstr);
      } else {
        setEndDate(null);
      }
    },
    [setStartDate, setEndDate]
  );

  return { handleDateRange };
};
